import React from "react";
import SeasonGrades from "./SeasonGrades";
import { AiFillQuestionCircle } from "react-icons/ai";
import ReactTooltip from "react-tooltip";

export default function YourGrade(props) {
  const { formValues, grade, seasonGrades } = props;

  let letterGrade = "";

  if (grade >= 94) letterGrade = "A+";
  else if (grade < 94 && grade >= 90) letterGrade = "A";
  else if (grade < 90 && grade >= 85) letterGrade = "B+";
  else if (grade < 85 && grade >= 80) letterGrade = "B";
  else if (grade < 80 && grade >= 75) letterGrade = "C+";
  else if (grade < 74 && grade >= 70) letterGrade = "C";
  else letterGrade = "D+";

  let diffusionScore = "";
  if (formValues.clarity == "Most Clear") diffusionScore = "A";
  else if (formValues.clarity == "In-Between") diffusionScore = "B";
  else if (formValues.clarity == "Most Diffuse") diffusionScore = "C";
  else if (formValues.clarity == "Unknown") diffusionScore = "N/A";

  return (
    <div className="YourGrade">
      <div className="DiffusionScoreContainer">
        <div className="DiffusionScoreHeader">
          <h3>Diffusion Score</h3>
          <AiFillQuestionCircle
            className="QuestionIcon"
            data-tip="Greenhouses with high
        clarity recieve a high diffusion benefit from UbiGro. The score is N/A if you selected 'Unknown'."
          />
          <ReactTooltip />
        </div>
        <p className="DiffusionScoreExplain">
          This score is based on your greenhouse clarity.
        </p>
        <p className="DiffusionScore">{diffusionScore}</p>
      </div>
      <div className="SeasonGrades">
        <SeasonGrades seasonGrades={seasonGrades} formValues={formValues} />
      </div>
    </div>
  );
}
